import {
  ConsultationTypeActionTypes,
  CONSULTATION_TYPE_FAIL,
  CONSULTATION_TYPE_LOADING,
  CONSULTATION_TYPE_SUCCESS,
  ConsultationTypeState,
  CONSULTATION_TYPE_API_MSG,
  CONSULTATION_TYPE_API_RES,
} from "./ActionTypes";
import { ConsultationTypeListResponse } from "./Model";

const initialStateEditPosts: ConsultationTypeState = {
  loading: false,
  consultationTypeResponse: {} as ConsultationTypeListResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const consultationTypeReducer = (
  state = initialStateEditPosts,
  action: ConsultationTypeActionTypes
): ConsultationTypeState => {
  switch (action.type) {
    case CONSULTATION_TYPE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case CONSULTATION_TYPE_SUCCESS:
      return {
        ...state,
        consultationTypeResponse: action.payload,
        successMsg: action.successMsg,
      };
    case CONSULTATION_TYPE_FAIL:
      return {
        ...state,
        consultationTypeResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case CONSULTATION_TYPE_API_MSG:
      return {
        ...state,
        consultationTypeResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case CONSULTATION_TYPE_API_RES:
      return {
        ...state,
        consultationTypeResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
